import React from "react";
import { UseFormReturn } from "react-hook-form";
import CustomInput from "src/components/CustomInput";

import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/components/ui/dialog";

import { Button } from "src/components/ui/button";
import { Form } from "src/components/ui/form";
import { ExpenseAndIncomeSubCategorySchemaType } from "./expenseAndIncomeCategorySchema";

interface ExpenseAndIncomeSubCategoryFormModalProps {
  isShow: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: UseFormReturn<ExpenseAndIncomeSubCategorySchemaType, any, any>;
  type: "CREATE" | "EDIT";
}

const ExpenseAndIncomeSubCategoryFormModal: React.FC<
  ExpenseAndIncomeSubCategoryFormModalProps
> = ({ isShow, onClose, onSubmit, form, type }) => {
  return (
    <Dialog open={isShow} onOpenChange={onClose}>
      <DialogContent className="max-w-fit">
        <DialogHeader>
          <DialogTitle className="text-md font-semibold text-darkBrown-default">
            {`${type === "CREATE" ? "Create" : "Edit"} Sub-Category`}
          </DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-4 pt-2 w-[860px]">
          <Form {...form}>
            <div className="w-full grid gap-4 mb-12">
              <CustomInput
                form={form}
                name="name"
                labelText="Sub-Category Name"
                placeholder="Input Name"
              />
            </div>
          </Form>
        </div>

        <DialogFooter>
          <Button onClick={onSubmit} isLoading={form.formState.isSubmitting}>
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ExpenseAndIncomeSubCategoryFormModal;
